import * as translations from '../../../../i18n/translations';

export interface IMilestone {
  workoutsToComplete: number;
  isRewardMilestone: boolean;
  milestoneText: string;
  milestoneCompletedText: string;
}

export function getMilestoneData(): IMilestone[] {
  return [
    {
      workoutsToComplete: 1,
    },
    {
      workoutsToComplete: 5,
    },
    {
      workoutsToComplete: 25,
    },
    {
      workoutsToComplete: 50,
    },
    {
      workoutsToComplete: 75,
    },
    {
      workoutsToComplete: 100,
      isRewardMilestone: true,
    },
    {
      workoutsToComplete: 150,
    },
    {
      workoutsToComplete: 200,
      isRewardMilestone: true,
    },
    {
      workoutsToComplete: 250,
    },
    {
      workoutsToComplete: 300,
      isRewardMilestone: true,
    },
    {
      workoutsToComplete: 350,
    },
    {
      workoutsToComplete: 400,
      isRewardMilestone: true,
    },
    {
      workoutsToComplete: 450,
    },
    {
      workoutsToComplete: 500,
      isRewardMilestone: true,
    },
  ].map(milestone => ({
    ...milestone,
    isRewardMilestone: Boolean(milestone.isRewardMilestone),
    milestoneCompletedText: translations[
      `milestoneTextCompleted${milestone.workoutsToComplete}`
    ](),
    milestoneText: translations['milestoneText'](milestone.workoutsToComplete),
  }));
}
